import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Star, Shield, Users } from 'lucide-react';
import { WhatsAppButton } from './WhatsAppButton';
export function Hero() {
  const benefits = ['Atención personalizada', 'Lecturas energéticas precisas', 'Fotomancia a distancia', 'Limpieza energética de hogares y negocios', 'Atención presencial en Antofagasta', 'Total confidencialidad'];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="relative min-h-screen flex items-center pt-24 pb-16 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-122">
      <div className="max-w-7xl mx-auto w-full" data-id="element-123">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-124">
          {/* Text Content */}
          <motion.div variants={containerVariants} initial="hidden" animate="visible" className="order-2 lg:order-1" data-id="element-125">
            <motion.h1 variants={itemVariants} className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-6" data-id="element-126">
              ¿Sientes que algo no fluye en tu vida y{' '}
              <span className="text-gradient-gold" data-id="element-127">buscas respuestas?</span>
            </motion.h1>

            <motion.p variants={itemVariants} className="text-lg sm:text-xl text-mystic-white/80 mb-8 leading-relaxed font-light" data-id="element-128">
              A través de la videncia, la fotomancia y la limpieza energética
              profesional, descubre las influencias que pueden estar afectando
              tu bienestar, tus relaciones y tu camino personal.
            </motion.p>

            <motion.ul variants={itemVariants} className="grid sm:grid-cols-2 gap-4 mb-10" data-id="element-129">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-130">
                  <CheckCircle2 className="w-5 h-5 text-mystic-gold shrink-0 mt-0.5" data-id="element-131" />
                  <span className="text-mystic-white/90 text-sm sm:text-base" data-id="element-132">
                    {benefit}
                  </span>
                </li>)}
            </motion.ul>

            <motion.div variants={itemVariants} className="flex flex-col sm:flex-row gap-4 mb-12" data-id="element-133">
              <WhatsAppButton text="Hablar por WhatsApp" variant="primary" message="Hola Maestro Navy, busco respuestas y me gustaría agendar una consulta." data-id="element-134" />
              <WhatsAppButton text="Solicitar orientación" variant="outline" message="Hola Maestro Navy, necesito orientación sobre mi situación actual." data-id="element-135" />
            </motion.div>

            {/* Trust Indicators */}
            <motion.div variants={itemVariants} className="grid grid-cols-3 gap-4 pt-8 border-t border-mystic-gold/20" data-id="element-136">
              <div className="flex flex-col items-center text-center gap-2" data-id="element-137">
                <Star className="w-6 h-6 text-mystic-gold" data-id="element-138" />
                <span className="text-xs sm:text-sm text-mystic-white/70" data-id="element-139">
                  Más de 20 años
                  <br data-id="element-140" />
                  de experiencia
                </span>
              </div>
              <div className="flex flex-col items-center text-center gap-2" data-id="element-141">
                <Shield className="w-6 h-6 text-mystic-gold" data-id="element-142" />
                <span className="text-xs sm:text-sm text-mystic-white/70" data-id="element-143">
                  Atención
                  <br data-id="element-144" />
                  personalizada
                </span>
              </div>
              <div className="flex flex-col items-center text-center gap-2" data-id="element-145">
                <Users className="w-6 h-6 text-mystic-gold" data-id="element-146" />
                <span className="text-xs sm:text-sm text-mystic-white/70" data-id="element-147">
                  Clientes
                  <br data-id="element-148" />
                  satisfechos
                </span>
              </div>
            </motion.div>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="order-1 lg:order-2 relative flex justify-center" data-id="element-149">
            {/* Decorative elements behind image */}
            <div className="absolute inset-0 bg-mystic-gold/20 rounded-full blur-[100px] animate-pulse-slow" data-id="element-150"></div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[110%] h-[110%] rounded-full border border-mystic-gold/30 border-dashed animate-[spin_60s_linear_infinite]" data-id="element-151"></div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] rounded-full border border-mystic-blue-800/50 animate-[spin_40s_linear_infinite_reverse]" data-id="element-152"></div>

            <div className="relative z-10 w-64 h-64 sm:w-80 sm:h-80 lg:w-96 lg:h-96 rounded-full p-2 bg-gradient-to-br from-mystic-gold/40 to-mystic-blue-900/40 backdrop-blur-sm" data-id="element-153">
              <div className="w-full h-full rounded-full overflow-hidden border-2 border-mystic-gold/50 relative" data-id="element-154">
                <img src="https://cdn.magicpatterns.com/uploads/5tpH95544We3gmijLiP7sL/__prompt____Ultra-photorealistic_portrait_of_202605241506.jpg" alt="Maestro Navy - Terapeuta Energético" className="w-full h-full object-cover object-center" data-id="element-155" />
                <div className="absolute inset-0 bg-gradient-to-t from-mystic-black/60 via-transparent to-transparent" data-id="element-156"></div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}